module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j7CSl"))).then(() => parcelRequire('ax2A4'));